import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import {
  appBaseUrl,
  appBotApi,
  appGeneratePromptApi,
  appThreadApi,
} from "../../config/apiConfig";
import type { RunInfo } from "../../methodsTypes";
import type {
  AssistantFunction,
  AssistantFunctionRunOutput,
  AssistantFunctionRunPostObjType,
  AssistantFunctionsResponse,
  AssistantFunctionToolOutput,
  AssistantNewFunctionType,
  AssistantToolsFunctionSchema,
  GeneratePromptRequest,
  GeneratePromptResponse,
} from "./types";

export const deleteAssistant = (id: string): Promise<string> => {
  return appThreadApi
    .delete("/v1/assistants/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then(() => id);
};

export const getAssistantFunctions = (
  id: string,
): Promise<AssistantFunction[]> => {
  return appBotApi
    .get<AssistantFunctionsResponse>("/v1/function/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data.functions);
};

export const deleteAssistantFunction = (id: string, functionName: string) => {
  return appBotApi
    .delete(`/v1/function/${id}/${functionName}`, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getAssistantFunctionSchema = (
  assistantId: string,
  functionUrl: string,
): Promise<{ schema: AssistantToolsFunctionSchema }> => {
  return appBotApi
    .get(`/v1/function/${assistantId}/${functionUrl}/schema`, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const runAssistantFunction = (
  functionName: string,
  postObj: AssistantFunctionRunPostObjType,
): Promise<AssistantFunctionRunOutput> => {
  return appBotApi
    .post(`/v1/function/${functionName}/run`, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const submitAssistantToolOutputs = (
  threadId: string,
  runId: string,
  postObj: { tool_outputs: AssistantFunctionToolOutput[] },
): Promise<RunInfo> => {
  return appThreadApi
    .post(
      `/v1/threads/${threadId}/runs/${runId}/submit_tool_outputs`,
      postObj,
      {
        withCredentials: false,
        headers: {
          "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
        },
      },
    )
    .then((res) => res.data);
};

export const addAssistantFunction = (
  postObj: AssistantNewFunctionType,
): Promise<string> => {
  return appBotApi
    .post("/v1/function/", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const generatePrompt = (
  postObj: GeneratePromptRequest,
): Promise<GeneratePromptResponse> => {
  return appGeneratePromptApi
    .post("", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getText = (file: File, signal?: AbortSignal): Promise<string> => {
  const formData = new FormData();
  formData.append("input_file", file);

  return appBaseUrl
    .post("/text-extractor/get_text", formData, {
      withCredentials: false,
      signal: signal,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
